
import Brush1 from "../../../assets/duotone/Brush1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Brush1Icon({ className, dataTestid = "Brush1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Brush1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
